#@export GliveBooking.Models.Section

class GliveBooking.Models.Section extends BookingV2.Models.Base

  getTitle: ->
    @get('title')
